import * as React from 'react';

import AppBarM, { AppBarProps } from '@mui/material/AppBar';

export interface Props extends AppBarProps {
  /**
   * The content of the component.
   */
  children?: React.ReactNode;
  /**
   * Override or extend the styles applied to the component. See CSS API https://mui.com/api/app-bar/#css for more details.
   */
  classes?: AppBarProps['classes'];
  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color?: AppBarProps['color'];
  /**
   * If true, the color prop is applied in dark mode.
   */
  enableColorOnDark?: boolean;
  /** The positioning type. The behavior of the different options is described in the MDN web docs
   * https://developer.mozilla.org/en-US/docs/Learn/CSS/CSS_layout/Positioning.
   * Note: sticky is not universally supported and will fall back to static when unavailable. */
  position?: AppBarProps['position'];
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   * See the `sx` page for more details https://mui.com/system/the-sx-prop/.
   */
  sx?: AppBarProps['sx'];
}

function AppBar(props: Props) {
  return (
    <AppBarM {...props} sx={props.sx}>
      {props.children}
    </AppBarM>
  );
}

export default AppBar;
